import React from 'react';
import {TextInputComponent, TextInputProps} from '@gongxigames/framework/core/fragments/react';

const TEXT_STYLE = {
    fontWeight: 'bold',
    fontFamily: 'PF DinDisplay Pro',
    fontSize: '72px',
    padding: '10px 20px',
    color: 'white'
};

const DEFAULT_BACKGROUND_COLOR = 0x555555;
const NOT_VALID_BACKGROUND_COLOR = 0xff0000;
const BOX_ROUND = 20;

type CheatTextInputProps = Omit<TextInputProps, 'textStyle' | 'boxStyle' | 'text'> & {
    onChange: (value: string) => void;
    value: string;
    placeholder?: string;
    isInvalid?: boolean;
    restrict?: RegExp;
};

export class CheatTextInput extends React.Component<CheatTextInputProps> {
    protected onInput(text: string): void {
        this.props.onChange(text);
        this.forceUpdate();
    }

    public render(): JSX.Element {
        const {
            onChange,
            value,
            isInvalid,
            width,
            ...props
        } = this.props;
        const boxStyle = {fill: isInvalid ? NOT_VALID_BACKGROUND_COLOR : DEFAULT_BACKGROUND_COLOR, rounded: BOX_ROUND};

        return (
            <TextInputComponent
                {...props as any}
                textStyle={{...TEXT_STYLE, width: `${width}px`}}
                boxStyle={{default: boxStyle}}
                text={value}
                input={this.onInput.bind(this)}
            />
        );
    }
}
